<template>
  <div :class="$style.ApplicationUserGroups">
    <p>
      The following user groups are bound to {{ item.name }}.
      Users will have access in their User Portal.
    </p>
    <UserGroupItemTable
      ref="itemTable"
      :boundItemsUrl="boundItemsUrl"
      :inDetailsAsidePanel="true"
      :panelType="panelType"
    />
  </div>
</template>
<script>
import { ItemTableConsts } from 'client/util/Constants';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import ItemTableMethodsMixin from 'client/components/ItemTable/mixins/ItemTableMethodsMixin';
import UserGroupItemTable from 'client/components/ItemTable/UserGroupItemTable.vue';

export default {
  name: 'ApplicationUsersGroups',

  components: {
    UserGroupItemTable,
  },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
    ItemTableMethodsMixin,
  ],

  props: {
    itemId: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      boundItemsUrl: this.itemId
        ? `/api/v2/applications/${this.itemId}/usergroups`
        : undefined,
      panelType: ItemTableConsts.panelType.applicationAsidePanel,
    };
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },
};
</script>

<style module>
  .ApplicationUserGroups {
    margin-top: 20px;
    overflow-x: auto;
  }

  .ApplicationUserGroups p {
    margin-left: 20px;
  }
</style>
